import { createPersistentStore } from "./store";
export const reload = createPersistentStore('reload', false);
